import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import messages from '../../locale/messages';
import InboxEmailConfigurationContainer from './InboxEmailConfigurationContainer';

const title = 'Inbox';

export default function action({ store, intl, query }) { // Add query to destructured props
  const title = intl?.formatMessage(messages.inbox);

  // From Redux Store
  const isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    return { redirect: '/login' };
  }

  // Check if hosting query param exists (works with ?hosting or ?hosting=true)
  const isHosting = query.hosting !== undefined;

  return {
    title,
    component: (
      <UserLayout>
        <InboxEmailConfigurationContainer
          title={title}
          {...(isHosting && { isHosting: true })} // Only pass isHosting if true
        />
      </UserLayout>
    ),
  };
}